import _slicedToArray from "@babel/runtime/helpers/slicedToArray";
import "core-js/modules/es.array.is-array.js";
import "core-js/modules/es.array.map.js";
import { buildShortenVersion, getMaxWordCountForInstantAnswerExplanation } from "@faire/help-center-utils/lib/textHelper";
import { getBrandToken } from "@faire/help-center-utils/serialized-data/getBrand";
import { getRetailerToken } from "@faire/help-center-utils/serialized-data/getRetailer";
import { trackCxFoundationsInstantanswerlearnmoreClick } from "@faire/web-api/events/cxFoundations/click/instantanswerlearnmore";
import { Spacer } from "@faire/web/slate/spacing";
import { Typography } from "@faire/web/slate/Typography";
import { useViewport } from "@faire/web/ui/hooks/useViewport";
import kebabCase from "lodash/kebabCase";
import React, { useState } from "react";
import { ShowMoreCta } from "./ShowMoreCta";
import { contentIsShorterThanMax } from "./utils";
export var InstantAnswerExplanation = function InstantAnswerExplanation(_ref) {
  var descriptionParagraphs = _ref.descriptionParagraphs,
    viewHasHelpCenterArticles = _ref.viewHasHelpCenterArticles;
  var _useState = useState(false),
    _useState2 = _slicedToArray(_useState, 2),
    userClickedOnShowMore = _useState2[0],
    setUserClickedOnShowMore = _useState2[1];
  var _useViewport = useViewport(),
    isTabletAndAbove = _useViewport.isTabletAndAbove;
  var maxVisibleDescriptionWords = getMaxWordCountForInstantAnswerExplanation(viewHasHelpCenterArticles);
  var retailerToken = getRetailerToken();
  var brandToken = getBrandToken();
  if (Array.isArray(descriptionParagraphs)) {
    if (descriptionParagraphs.length === 0) {
      return null;
    }
    var showFullExplanation = userClickedOnShowMore || isTabletAndAbove || !viewHasHelpCenterArticles || contentIsShorterThanMax(descriptionParagraphs, maxVisibleDescriptionWords);
    if (showFullExplanation) {
      return /*#__PURE__*/React.createElement(React.Fragment, null, descriptionParagraphs.map(function (description, index) {
        return /*#__PURE__*/React.createElement("div", {
          key: index
        }, index > 0 ? /*#__PURE__*/React.createElement(Spacer, {
          height: "2x"
        }) : null, /*#__PURE__*/React.createElement(Typography, {
          "data-test-id": "".concat(kebabCase(description), "-des")
        }, description));
      }));
    }
    var firstParagraph = descriptionParagraphs[0];
    var shortenFirstParagraph = buildShortenVersion(firstParagraph, maxVisibleDescriptionWords);
    var thereIsMoreContentToShow = shortenFirstParagraph.length - "...".length <= firstParagraph.length || descriptionParagraphs.length > 1;
    var showMoreCtaOnClickHandler = function showMoreCtaOnClickHandler() {
      setUserClickedOnShowMore(true);
      trackCxFoundationsInstantanswerlearnmoreClick(retailerToken !== null && retailerToken !== void 0 ? retailerToken : "", brandToken !== null && brandToken !== void 0 ? brandToken : "");
    };
    return /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement(Typography, {
      "data-test-id": "instant-answer-cut-description"
    }, shortenFirstParagraph, /*#__PURE__*/React.createElement(ShowMoreCta, {
      visibleWhen: thereIsMoreContentToShow,
      onClick: showMoreCtaOnClickHandler
    })));
  }
  return /*#__PURE__*/React.createElement(React.Fragment, null, descriptionParagraphs);
};